<div *ngFor="let alert of alerts | slice: 0:MAX_VISIBLE" [@flyInOut]>
    <q-alert-view [alert]="alert" (onAlertClose)="handleAlertClosed($event)">
    </q-alert-view>
</div>
<div
    class="float-right badge badge-secondary dark-shadow-sm"
    *ngIf="alerts.length > MAX_VISIBLE"
>
    Showing {{ MAX_VISIBLE }} of {{ alerts.length }} ...
</div>
